import React, { Component } from "react";
import { connect } from "react-redux";
import NoticeApis from "../../../../utils/noticeApis";
import {
  Skeleton,
  PageHeader,
  Typography,
  Button,
  Icon,
  Row,
  Select,
  Input,
  Table
} from "antd";
import { withRouter } from "react-router-dom";
import { getKoreanDate } from "../../../../utils/utils";

const count = 10;
class NoticeListPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      noticeList: [],
      searchType: "all",
      page: 0,
      totalPages: 1
    };
  }

  componentDidMount() {
    this.getNoticeList();
  }

  getNoticeList = (page = 0) => {
    NoticeApis.getNoticeList(page, count)
      .then(res => {
        console.log("notice list: ", res);
        this.setState({
          noticeList: res.list,
          page: res.page,
          totalPages: res.totalPages
        });
      })
      .catch(e => {
        console.log("notice list error: ", e);
      });
  };

  onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
    this.setState(
      {
        page: pagination.current - 1
      },
      () => {
        this.getNoticeList(pagination.current - 1);
      }
    );
  };

  render() {
    const { noticeList, isLoading, page, totalPages } = this.state;
    const { user, userPermission } = this.props;

    return (
      <Skeleton loading={isLoading} active>
        <PageHeader
          title={
            <Typography.Title level={2} style={{ marginBottom: 0 }}>
              공지사항
            </Typography.Title>
          }
          extra={
            userPermission === "master" ||
            (userPermission && userPermission.notice)
              ? [
                  <Button
                    key="1"
                    type="primary"
                    onClick={() => this.props.history.push("/admin/notice/add")}
                  >
                    공지 등록하기
                    <Icon type="plus-circle" />
                  </Button>
                ]
              : null
          }
        />
        <div className="admin-page-content">
          <Row
            type="flex"
            justify="end"
            style={{ marginBottom: 28, display: "none" }}
          >
            <Select
              defaultValue="all"
              value={this.state.searchType}
              onChange={value =>
                this.setState({
                  searchType: value
                })
              }
            >
              <Select.Option value="all">제목+내용</Select.Option>
              <Select.Option value="title">제목만</Select.Option>
              <Select.Option value="content">내용만</Select.Option>
            </Select>
            <Input.Search
              style={{ width: 200, marginLeft: 8 }}
            />
          </Row>
          <Table
            rowKey="noticeId"
            dataSource={noticeList}
            columns={[
              {
                title: "번호",
                key: "index",
                render: (text, record, index) => (
                  <span>{record.noticeId}</span>
                )
              },
              {
                title: "제목",
                key: "title",
                dataIndex: "title",
                render: text => <span>{text}</span>
              },
              {
                title: "작성자",
                key: "name",
                dataIndex: "writer",
                render: text => <span>{text.name}</span>
              },
              {
                title: "등록일",
                key: "createdTime",
                dataIndex: "createdTime",
                render: text => <span>{getKoreanDate(text, true)}</span>
              }
            ]}
            onRow={record => {
              return {
                onClick: () => {
                  this.props.history.push(
                    `/admin/notice/detail/${record.noticeId}`
                  );
                }
              };
            }}
            pagination={{
              defaultPageSize: count,
              total: totalPages * count
            }}
            onChange={this.onChange}
          />
        </div>
      </Skeleton>
    );
  }
}

export default withRouter(
  connect(
    ({ auth }) => ({
      pending: auth.pending,
      auth: auth,
      user: auth.user,
      logged: auth.logged,
      userPermission: auth.user.type === "org" ? "master" : auth.user.permission
    }),
    null
  )(NoticeListPage)
);
